import { render, staticRenderFns } from "./PlayerCards.vue?vue&type=template&id=30d6445c&scoped=true&"
import script from "./PlayerCards.vue?vue&type=script&lang=ts&"
export * from "./PlayerCards.vue?vue&type=script&lang=ts&"
import style0 from "./PlayerCards.vue?vue&type=style&index=0&id=30d6445c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d6445c",
  null
  
)

export default component.exports